// app/javascript/src/pages/Admin/PaymentTerms/PaymentTermForm/TermTypeToggle.tsx
import "./style.css";
import { TERM_TYPE_OPTIONS } from "../types";
import type { TermType } from "../types";

export interface TermTypeToggleProps {
  value: TermType;
  onChange: (next: TermType) => void;
}

const DESCRIPTIONS: Record<TermType, string> = {
  percent:
    "Bill each term as a percentage of the project total (must add to 100%).",
  milestone: "Bill each term when a project phase milestone is reached.",
};

export const TermTypeToggle = ({
  value,
  onChange,
}: TermTypeToggleProps): JSX.Element => (
  <div className="row termTypeCardRow">
    {TERM_TYPE_OPTIONS.map((opt) => {
      const selected = value === opt.value;
      return (
        <div className="col-sm-6" key={opt.value}>
          <label className={`termTypeCard ${selected ? "selected" : ""}`}>
            <input
              type="radio"
              name="term-type"
              value={opt.value}
              checked={selected}
              aria-label={opt.label}
              onChange={() => {
                if (!selected) onChange(opt.value);
              }}
              className="termTypeCardInput"
            />
            <span className="termTypeRadio" aria-hidden>
              {selected && <span className="termTypeRadioInner" />}
            </span>
            <span className="termTypeCardText">
              <span className="termTypeCardTitle">{opt.label}</span>
              <span className="termTypeCardDesc">
                {DESCRIPTIONS[opt.value]}
              </span>
            </span>
          </label>
        </div>
      );
    })}
  </div>
);

export default TermTypeToggle;
